export default "__VITE_PUBLIC_ASSET__07e9b127__"